import { createContext, ReactNode, useContext } from "react";
import { MetadataType } from "../../../../../../types";

type IEnrichmentCardContext = {
  getMdLabelsByType: (type: MetadataType) => string[];
  isSingleItem: boolean;
};

const EnrichmentCardContext = createContext<IEnrichmentCardContext>({
  getMdLabelsByType: () => [],
  isSingleItem: false,
});

export const useEnrichmentCardContext = () => useContext(EnrichmentCardContext);

export const EnrichmentCardProvider = ({
  children,
  getMdLabelsByType,
  isSingleItem,
}: IEnrichmentCardContext & { children?: ReactNode }) => (
  <EnrichmentCardContext.Provider value={{ getMdLabelsByType, isSingleItem }}>
    {children}
  </EnrichmentCardContext.Provider>
);
